import type { StyleSystemProps } from '@withjoy/joykit';
import { Flex, styled } from '@withjoy/joykit';

export const StyledRootContainer = styled(Flex)``;
export const StyledFilterContainer = styled(Flex)``;
export const StyledFilter = styled(Flex)``;
export const StyledTotalFilters = styled(Flex)``;
export const StyledFloatingFilter = styled(Flex)``;
export const StyledSortByPriceMobileContainer = styled(Flex)``;

type FilterContainerProps = { isMobileOrTablet: boolean };

const totalFiltersStyles = (props: FilterContainerProps): StyleSystemProps => {
  return {
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
    width: [6],
    height: [6],
    borderRadius: ['50%'],
    ...(props.isMobileOrTablet
      ? {
          color: 'white',
          backgroundColor: 'mono12',
        }
      : {
          color: 'white',
          backgroundColor: 'black',
          _groupHover: {
            backgroundColor: 'primary6',
          },
        }),
  };
};

const rootContainerStyles: StyleSystemProps = {
  alignItems: 'center',
};

const filterStyles: StyleSystemProps = {
  cursor: 'pointer',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'black',
  _hover: {
    color: 'primary6',
  },
};

const floatingFilterStyles: StyleSystemProps = {
  alignItems: 'wrap',
  color: 'white',
  borderRadius: '28px',
  backgroundColor: '#000000',
  width: 'max-content',
  paddingLeft: 6,
  paddingRight: 0,
  paddingY: 0,
  _active: {
    backgroundColor: 'mono14',
  },
};

const floatingFilterContainerStyles: (isAdmin?: boolean) => StyleSystemProps = isAdmin => ({
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  position: 'fixed',
  bottom: isAdmin ? '85px' : '40px',
  zIndex: 99,
});

const sortByPriceMobileContainerStyles = (isSelected: boolean = false): StyleSystemProps => ({
  position: 'relative',
  paddingX: 7,
  paddingY: 5,
  alignItems: 'center',
  borderRadius: '0 28px 28px 0',
  backgroundColor: isSelected ? 'mono14' : null,
});

const filterContainerStyles: StyleSystemProps = {
  height: [5, null, 8],
  alignItems: 'center',
  whiteSpace: 'nowrap',
  columnGap: 6,
};

const filterContainerFixedStyles: StyleSystemProps = {
  alignItems: 'center',
  whiteSpace: 'nowrap',
  columnGap: 6,
};

const verticalDividerStyles: StyleSystemProps = {
  marginLeft: 28,
  width: '2px',
  backgroundColor: 'mono14',
};

export const styles = {
  totalFilters: totalFiltersStyles,
  rootContainer: rootContainerStyles,
  filter: filterStyles,
  floatingFilter: floatingFilterStyles,
  stickyContainer: floatingFilterContainerStyles,
  filterContainer: filterContainerStyles,
  filterContainerFixed: filterContainerFixedStyles,
  sortByPriceMobileContainer: sortByPriceMobileContainerStyles,
  verticalDivider: verticalDividerStyles,
};
